import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import CasinoRoundedIcon from '@mui/icons-material/CasinoRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';
import Button from '@mui/material/Button';
import { useCallback } from 'react';
import { isMobile } from 'react-device-detect';
import { IconWithLabelDisplay } from '../../../../components/iconWithLabelDisplay';
import { PANEL_ITEM_PADDING_CSS } from '../../../../panels/panelItem';
import { PanelItemDivider } from '../../../../panels/panelItemDivider';
import { setIsSelectingSideBetTarget } from '../../../../redux/actions/sideBetsActions';
import { selectSideBettingState } from '../../../../redux/selectorFns';
import { useAppDispatch, useAppSelector } from '../../../../redux/store';
import { LIGHT_BLUE_COLOR, SIDE_BETS_PANEL_BACKGROUND_COLOR } from '../../../../styles/colors';
import { SideBetButtonLabel } from './sideBetButtonLabel';
const CONTAINER_CSS = css(PANEL_ITEM_PADDING_CSS, css `
    width: 100%;
  `);
const SIDE_BET_PLACED_ITEM_CSS = css(CONTAINER_CSS, css `
    color: ${LIGHT_BLUE_COLOR};
  `);
const SELECTING_PLAYER_TEXT_CSS = css `
  font-size: 80%;
  color: ${LIGHT_BLUE_COLOR};
  text-align: center;
`;
function getButtonLabel(sideBettingState, isSelectingSideBetTarget) {
    if (sideBettingState === 'disabled') {
        return _jsx(SideBetButtonLabel, {});
    }
    if (isSelectingSideBetTarget) {
        return 'Cancel';
    }
    return _jsx(SideBetButtonLabel, {});
}
export const SelectSideBetButtonContainer = () => {
    const sideBettingState = useAppSelector(selectSideBettingState);
    const isSelectingSideBetTarget = useAppSelector((state) => state.sideBets.selectSideBetTargetStartTimestampMs !== undefined);
    const isMySideBetPlaced = useAppSelector((state) => state.sideBets.myPlacedSideBetTargetPlayerId !== undefined);
    const dispatch = useAppDispatch();
    const onClick = useCallback(() => {
        dispatch(setIsSelectingSideBetTarget(!isSelectingSideBetTarget));
    }, [dispatch, isSelectingSideBetTarget]);
    if (sideBettingState === 'off') {
        return null;
    }
    if (isMySideBetPlaced) {
        return (_jsxs(_Fragment, { children: [_jsx("div", { css: SIDE_BET_PLACED_ITEM_CSS, children: _jsx(IconWithLabelDisplay, { icon: _jsx(CheckCircleRoundedIcon, {}), label: 'Side Bet Placed' }) }), _jsx(PanelItemDivider, { color: SIDE_BETS_PANEL_BACKGROUND_COLOR, thicknessPx: 2 })] }));
    }
    return (_jsxs("div", { css: CONTAINER_CSS, children: [_jsx(Button, { onClick: onClick, variant: 'contained', fullWidth: true, startIcon: isSelectingSideBetTarget ? _jsx(HighlightOffRoundedIcon, {}) : _jsx(CasinoRoundedIcon, {}), disabled: sideBettingState === 'disabled', color: isSelectingSideBetTarget ? 'secondary' : 'primary', children: getButtonLabel(sideBettingState, isSelectingSideBetTarget) }), isSelectingSideBetTarget && (_jsxs("div", { css: SELECTING_PLAYER_TEXT_CSS, children: [isMobile ? 'TAP' : 'CLICK', " PLAYER TO SIDE BET"] }))] }));
};
